import TomSelect from "tom-select";
import { Notyf } from "notyf";
import intlTelInputWithUtils from "intl-tel-input/build/js/intlTelInputWithUtils.js";
import Helpers from "../utils/helpers";

const Checkout = {
  /**
   * Notyf object
   */
  notyf: null,

  /**
   * intl-tel-input object
   */
  iti: null,

  init() {
    if ($("body").hasClass("woocommerce-order-received")) {
      return;
    }

    this.initNotyf();

    this.load();
    this.events();

    this.initBillingPhone();
  },

  initNotyf() {
    this.notyf = new Notyf({
      duration: 0,
      ripple: false,
      position: {
        x: "left",
        y: "bottom",
      },
      types: [
        {
          type: "error",
          background: "#fff0f0",
        },
      ],
    });
  },

  load() {
    // Billing person.
    const person = $("input[name=billing_person]:checked").val();
    Checkout.handlePerson(person);

    // Shipping method.
    const methodEl = $('input[name="shipping_method[0]"]:checked');
    Checkout.handleShippingOptions(methodEl);
    Checkout.handlePaymentOptions(methodEl);
    Checkout.filterPaymentsByPerson(person);

    // Payment method.
    const paymentMethod = $("input[name=payment_method]:checked").val();
    Checkout.showPaymentForm(paymentMethod);

    setTimeout(() => {
      Checkout.copyInfo();
      Checkout.calcTotal();
    }, 150);
  },

  events() {
    $("body").on("cab_checkout_error", () => {
      const termsEl = $("#terms");
      if (!termsEl.prop("checked")) {
        termsEl.addClass("error");
      } else {
        termsEl.removeClass("error");
      }
    });

    // Fix payment method filtering
    $("body").on("cab_updated_checkout", () => {
      const shippingMethodEl = $(
        'input[name="shipping_method[0]"]:checked'
      ).val();

      if (!shippingMethodEl) {
        return;
      }

      const shippingMethod = shippingMethodEl.split(":")[0];
      const paymentMethodEl = $("[name=payment_method]:checked").val();

      if ("local_pickup" !== shippingMethod && "cod" == paymentMethodEl) {
        setTimeout(() => {
          $("[name=payment_method]").prop("checked", false);
          $("[name=payment_method]")
            .first()
            .prop("checked", true)
            .trigger("change");
          Checkout.filterPaymentsByPerson(
            $("input[name=billing_person]:checked").val()
          );
        }, 50);
      }
    });

    $(".woocommerce-form-login").on("submit", function (e) {
      const form = $(this);

      if (!Helpers.validate(form)) {
        e.preventDefault();
        Checkout.notyf.error(translations.required);
      }
    });

    $("button[data-step]").on("click", function () {
      const el = $(this);

      if (
        el.hasClass("checkout-nav-link") &&
        !el.hasClass("checkout-nav-link--filled")
      ) {
        return;
      }

      const nextStep = $(this).data("step");

      Checkout.nextStep(nextStep);
    });

    $("input[name=billing_person]").on("change", function () {
      const person = $(this).val();

      Checkout.handlePerson(person);
      Checkout.filterPaymentsByPerson(person);
      Checkout.refreshTotalsForPerson(person);
    });

    // $('select[name="shipping_country"]').on("change", function () {
    //   const country = $(this).val();
    //   Checkout.showShippingZone(country);
    // });

    // On VAT change
    const isVat = $('input[name="billing_is_vat"]').is(":checked");
    Checkout.showVatField(isVat);

    $('input[name="billing_is_vat"]').on("change", function () {
      const isVat = $(this).is(":checked");

      Checkout.showVatField(isVat);
    });

    // On shipping method change
    $('input[name="shipping_method[0]"]').on("change", function () {
      const methodEl = $(this);
      $('input[name="shipping_method[0]"]').removeAttr("checked");

      methodEl.attr("checked", "checked");

      Checkout.handleShippingOptions(methodEl);
      Checkout.handlePaymentOptions(methodEl);
      Checkout.filterPaymentsByPerson(
        $("input[name=billing_person]:checked").val()
      );
    });

    // On payment method change
    $("input[name=payment_method]").on("change", function () {
      const paymentMethod = $(this).val();
      Checkout.showPaymentForm(paymentMethod);
    });

    // Disable enter key
    $(document).on("keydown", ".woocommerce-checkout", function (event) {
      return event.key != "Enter";
    });
  },

  initBillingPhone() {
    const billingPhone = document.querySelector("#billing_phone");
    const cabPhone = document.querySelector("#cab_phone");
    if (cabPhone) {
      Checkout.iti = intlTelInputWithUtils(cabPhone, {
        initialCountry: "ee",
        separateDialCode: true,
      });

      billingPhone.value = Checkout.iti.getNumber();

      cabPhone.addEventListener("change", (e) => {
        billingPhone.value = Checkout.iti.getNumber();
      });
    }
  },

  showShippingZone(country) {
    $("[data-countries]").each(function () {
      let countries = $(this).data("countries").split(",");
      if (countries.includes(country)) {
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
    });
  },

  showVatField(isVat) {
    const vatEl = $("[data-vat]");
    if (isVat) {
      vatEl.removeClass("hidden");
      vatEl.find("input").removeClass("disabled");
    } else {
      vatEl.addClass("hidden");
      vatEl.find("input").addClass("disabled");
    }
  },

  showPaymentForm(paymentMethod) {
    $("[data-payment]").each(function () {
      let paymentMethods = $(this).data("payment").split(",");
      if (paymentMethods.includes(paymentMethod)) {
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
    });
  },

  handleShippingOptions(methodEl) {
    const courierFields = $(".shipping-courier");
    const deliveryFields = $(".shipping-delivery");
    const pickupFields = $(".shipping-pickup");

    // Hide all fields
    $(".shipping-method-fields").addClass("hidden");

    courierFields.addClass("hidden");
    courierFields.find("input").addClass("disabled");
    deliveryFields.addClass("hidden");
    deliveryFields.find("input").addClass("disabled");
    pickupFields.addClass("hidden");
    pickupFields.find("input").addClass("disabled");

    if ("delivery" == methodEl.data("type")) {
      deliveryFields.removeClass("hidden");
      deliveryFields.find("input").removeClass("disabled");
    } else if ("courier" == methodEl.data("type")) {
      courierFields.removeClass("hidden");
      courierFields.find("input").removeClass("disabled");
    } else if ("pickup" == methodEl.data("type")) {
      pickupFields.removeClass("hidden");
      pickupFields.find("input").removeClass("disabled");
    }

    // Disable parcel select
    $("[data-method]").find("select").removeAttr("name");
    $("[data-method]").find("select").addClass("disabled");
    $("[data-method]").find("select").attr("disabled", "disabled");

    // Show fields based on selected method
    const targetFieldsEl = $(`[data-method="${methodEl.val()}"]`);

    targetFieldsEl.removeClass("hidden");

    const selectEl = targetFieldsEl.find("select");

    if (selectEl.length) {
      selectEl.removeAttr("disabled");
      selectEl.removeClass("disabled");

      if (!selectEl.hasClass("tomselected")) {
        new TomSelect(selectEl[0], {
          maxOptions: null,
        });
      }
    }

    if (selectEl) {
      selectEl.attr("name", selectEl.data("name"));
    }
  },

  handlePerson(person) {
    $(".billing[data-person]").addClass("hidden");
    $(".billing[data-person]").find("input").addClass("disabled");

    const targetPersonEl = $(`.billing[data-person="${person}"]`);
    targetPersonEl.removeClass("hidden");
    targetPersonEl.find("input").removeClass("disabled");

    Checkout.filterPaymentsByPerson(person);
  },

  /**
   * Recalculate cart VAT for person type and refresh step-3 totals.
   * Legal = VAT exempt (0%); private = normal rates.
   */
  refreshTotalsForPerson(person) {
    const $summaryWrap = $("#checkout-summary");
    const $productsWrap = $("#checkout-products");
    if (!$summaryWrap.length) {
      return;
    }

    $summaryWrap.addClass("loading");
    $productsWrap.addClass("loading");

    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: "json",
      data: {
        action: "set_checkout_person",
        person: person || "private",
      },
    })
      .done(function (resp) {
        if (!resp || !resp.success) {
          return;
        }

        if (resp.summary_html) {
          $summaryWrap.html(resp.summary_html);
        }

        if (resp.products_html && $productsWrap.length) {
          $productsWrap.html(resp.products_html);
        }

        if (resp.shipping_methods && resp.shipping_methods.length) {
          resp.shipping_methods.forEach(function (method) {
            const $input = $(
              'input[name="shipping_method[0]"][value="' + method.id + '"]'
            );
            if ($input.length) {
              $input.attr("data-cost", method.cost);
              $input.attr("data-vat", method.tax);
            }
          });
        }

        Checkout.calcTotal();
      })
      .always(function () {
        $summaryWrap.removeClass("loading");
        $productsWrap.removeClass("loading");
      });
  },

  /**
   * Legal persons: only bank transfer (BACS) is available.
   */
  filterPaymentsByPerson(person) {
    const isLegal = person === "legal";
    const methodEl = $('input[name="shipping_method[0]"]:checked');

    if (!isLegal) {
      $("[name=payment_method]").parent().removeClass("hidden");
      Checkout.handlePaymentOptions(methodEl);
      return;
    }

    $("[name=payment_method]").each(function () {
      const $input = $(this);
      const $li = $input.parent();
      if ($input.val() === "bacs") {
        $li.removeClass("hidden");
        if (!$input.is(":checked")) {
          $input.prop("checked", true).trigger("change");
        }
      } else {
        $li.addClass("hidden");
      }
    });
  },

  nextStep(nextStep) {
    Checkout.notyf.dismissAll();

    const currStep = parseInt($("#checkout").attr("data-step"));

    if (
      1 == currStep &&
      false === document.body.classList.contains("logged-in")
    ) {
      Checkout.goToStep(nextStep);
      return;
    }

    if (nextStep < currStep) {
      Checkout.goToStep(nextStep);
      return;
    }

    if (Helpers.validate($(`.step[data-step="${currStep}"]`))) {
      Checkout.goToStep(nextStep);

      return;
    }

    if ($(".parcel.error:not(.disabled)").length) {
      Checkout.notyf.error(translations.choose_parcel);
    }

    if ($(".field__input.error:not(.parcel):not(.disabled)").length) {
      Checkout.notyf.error(translations.required);
    }
  },

  goToStep(nextStep) {
    Checkout.handleNav(nextStep);

    const checkoutFormEl = $("#checkout");

    checkoutFormEl.attr("data-step", nextStep);

    if (nextStep > 1) {
      Checkout.calcTotal();
      Checkout.backupShipping();
    }
    if (nextStep > 2) {
      Checkout.copyInfo();
      Checkout.handlePersonPayment();
      // Recalculate VAT (0% for legal) before showing the final totals step.
      Checkout.refreshTotalsForPerson(
        $("input[name=billing_person]:checked").val()
      );
    }

    $("html, body").animate(
      { scrollTop: checkoutFormEl.offset().top - 200 },
      "fast"
    );

    $(`.step[data-step]`).addClass("hidden");
    $(`.step[data-step="${nextStep}"]`).removeClass("hidden");
  },

  backupShipping() {
    const shippinghMethodEl = $('input[name="shipping_method[0]"]:checked');

    if (!shippinghMethodEl || !shippinghMethodEl.val()) {
      return;
    }

    const backupEl = $("#shipping_backup");
    const shippingType = shippinghMethodEl.data("type");

    const shippingData = [];

    shippingData.push({
      name: "shipping_method",
      value: shippinghMethodEl.val().split(":")[0],
    });

    if ("courier" == shippingType) {
      $(".shipping-courier")
        .find("input")
        .each(function () {
          const el = $(this);
          shippingData.push({
            name: el.attr("name"),
            value: el.val(),
          });
        });
    } else if ("parcel_machine" == shippingType) {
      const parcelEl = $(
        `[data-method="${shippinghMethodEl.val()}"] select`
      ).first();

      shippingData.push({
        name: parcelEl.attr("name"),
        value: parcelEl.find("option:selected").text(),
      });
    } else {
      shippingData.push({
        name: shippinghMethodEl.val(),
        value: shippinghMethodEl.data("label"),
      });
    }

    backupEl.val(JSON.stringify(shippingData));
  },

  handleNav(step) {
    $(".checkout-nav-link").removeClass(
      "checkout-nav-link--active checkout-nav-link--filled"
    );
    $(".checkout-nav-link").each(function () {
      const navItemEl = $(this);
      const navStep = parseInt(navItemEl.data("step"));

      if (navStep < step) {
        navItemEl.addClass("checkout-nav-link--filled");
      } else if (navStep == step) {
        navItemEl.addClass("checkout-nav-link--active");
      }
    });
  },

  calcTotal() {
    // Get data.
    const totalsEl = $("#checkout-totals");
    const total = parseFloat(totalsEl.data("total"));
    const vat = parseFloat(totalsEl.data("vat"));
    const fee = parseFloat(totalsEl.data("fee"));
    const coupon = parseFloat(totalsEl.data("coupon")) || 0;
    const fees = totalsEl.find('.checkout-total-fees-data').data('fees');

    const currency = totalsEl.data("currency");

    // Total already includes coupon discount from backend, so use it directly
    let grandTotal = total;

    totalsEl.removeClass("hidden");

    // Shipping
    const shippingMethod = $('input[name="shipping_method[0]"]:checked');

    let shippingCost = parseFloat(shippingMethod.data("cost"));
    let shippingVat = parseFloat(shippingMethod.data("vat"));

    const shipping = {
      label: shippingMethod.data("label"),
      cost: shippingCost,
    };

    let totalVat = vat + shippingVat;

    $(".checkout-total-item--fee").html("");

    if (fees && fees.length > 0) {
      fees.forEach((fee, index) => {
        totalVat = totalVat + fee.tax;
        //grandTotal = grandTotal + fee.tax + fee.total;
        const feeWrapper = $(`.checkout-total-item--fee[data-fee-index="${index}"]`);

        // Add your label and value HTML here
        feeWrapper.html(`
          <p class="checkout-total-item__label">${fee.name}</p>
          <p class="checkout-total-item__value order-fee">${currency} ${fee.total.toFixed(2)}</p>
      `);
      });
    } else {
      $(".checkout-total-item--fee").html("");
    }

    $("#price-total-vat").text(`${currency} ${totalVat.toFixed(2)}`);

    // Add shipping to the already-calculated total (which includes coupons)
    grandTotal += shippingCost;

    if (shippingCost > 0) {
      let shippingHtml = `
        <p class="checkout-total-item__label">Piegāde: ${shipping.label}</p>
        <p class="checkout-total-item__value order-shipping">
          ${currency} ${shippingCost.toFixed(2)}
        </p>`;
      $(".checkout-total-item--shipping").html(shippingHtml);
    } else {
      $(".checkout-total-item--shipping").html("");
    }



    $("#price-grand-total").text(currency + " " + (grandTotal + totalVat).toFixed(2));
  },

  handlePaymentOptions(shippingMethodEl) {
    const inputShipping = shippingMethodEl.val();

    if (!inputShipping) {
      return;
    }
    const shippingMethod = inputShipping.split(":")[0];

    $("[name=payment_method]").each(function () {
      const paymentMethodEl = $(this);

      let shippingMethods = paymentMethodEl.data("shipping").split(",");

      shippingMethods = shippingMethods.filter((item) => item !== "");

      if (shippingMethods.length > 0) {
        if (shippingMethods.includes(shippingMethod)) {
          paymentMethodEl.parent().removeClass("hidden");
        } else {
          paymentMethodEl.parent().addClass("hidden");
        }
      }
    });
  },

  copyInfo() {
    let billingData = "";
    $("#billing input:not(.disabled)").each(function () {
      const el = $(this);

      if ("cab_phone" == el.attr("id")) {
        return;
      }

      billingData += `<li class="info-box__item">${el.val()}</li>`;
    });

    $(".cab-billing-info").html(billingData);

    const selectedShipping = $('[name="shipping_method[0]"]:checked');
    let shippingLabel = selectedShipping.siblings("label").text();
    let shippingData = `<li class="info-box__item">${shippingLabel}</li>`;

    let shippingExtra = $(
      `.shipping-method-fields[data-method="${selectedShipping.val()}"]`
    );
    if (shippingExtra.length) {
      let selectEl = shippingExtra.find("select option:selected");
      if (selectEl.length) {
        shippingData += `<li class="info-box__item">${selectEl.text()}</li>`;
      }
    }

    $(".cab-shipping-info").html(shippingData);
  },

  handlePersonPayment() {
    const person = $("input[name=billing_person]:checked").val();
    Checkout.filterPaymentsByPerson(person);
  },
};

export default Checkout;
